
const SidebarHelper = {
    // ---- methods ----
    checkPermissionList: (items, permissionList) => {
        if (!permissionList?.length) return items;

        const formattedPermissionList = [
            ...new Set(
                permissionList?.map((permission) => {
                    const path = permission?.path || '';
                    const parts = path.split('/').filter(Boolean);

                    if (parts.length === 0) return null;

                    if (parts.length === 1) {
                        return `/${parts[0]}`;
                    }

                    return '/' + parts.slice(0, -1).join('/');
                })
            )
        ].filter(Boolean);

        const itemsList = items
            ?.map((item) => {
                if (item.type === 'item') {
                    if (item?.subMenuItems) {
                        const filteredSubMenuItems = item.subMenuItems
                            .filter((subMenuItem) => formattedPermissionList?.includes(subMenuItem?.path))
                            ?.map((subMenuItem) => subMenuItem);

                        if (filteredSubMenuItems.length > 0) {
                            return {
                                ...item,
                                subMenuItems: filteredSubMenuItems,
                            };
                        }
                    }
                    if (formattedPermissionList?.includes(item?.path)) {
                        return item;
                    }
                } else return item;
                return null;
            })
            .filter((item) => item !== null);

        // Khi mà không có item nào thuộc section đó thì cũng không cần hiển thị section
        const result = [];
        for (let i = 0; i < itemsList.length; i++) {
            if (itemsList[i].type === 'section') {
                let hasItems = false;
                for (let j = i + 1; j < itemsList.length; j++) {
                    if (itemsList[j].type === 'section') break;
                    if (itemsList[j].type === 'item') {
                        hasItems = true;
                        break;
                    }
                }
                if (hasItems) result.push(itemsList[i]);
            } else {
                result.push(itemsList[i]);
            }
        }

        return result;
    },

};

export default SidebarHelper;
